import { StylesProps } from "@/types/props"
import classNames from "classnames"
import React from "react"
import NavigationItem, { NavigationItemProps } from "./NavigationItem"
import style from "./style.scss"

interface NavigationProps {
  className?: string
  styles?: StylesProps
  newMissionCount: number | null
  items: NavigationItemProps[]
}

const Navigation: React.SFC<Readonly<NavigationProps>> = (props) => {
  return (
    <nav className={classNames(style.navigation, props.className)}>
      <ul className={style.list}>
        {props.items &&
          props.items.map((item, index) => {
            return (
              <NavigationItem
                {...item}
                key={index}
                index={index}
                styles={props.styles}
                newMissionCount={props.newMissionCount}
                depth={0}
              />
            )
          })}
      </ul>
    </nav>
  )
}

export default Navigation
